import React from 'react'
import { TopTabBar as TopTabBarBase } from './styles'
import { MaterialTopTabBar as TopTabBarBaseBase } from '@react-navigation/material-top-tabs'

export default function TopTabBar(props) {
  return <TopTabBarBase {...props} />
}

TopTabBar.propTypes = TopTabBarBaseBase.propTypes
